"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gavorrano": {
    "5e974368": [{
      "hkey": "e6f56686",
      "slug": "gavorrano",
      "name": "Gavorrano",
      "primary": true,
      "skipSearch": false
    }],
    "casteani": [{
      "hkey": "e6f56686",
      "slug": "gavorrano",
      "name": "Gavorrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "30706951": [{
      "hkey": "e6f56686",
      "slug": "gavorrano",
      "name": "Gavorrano",
      "primary": true,
      "skipSearch": false
    }],
    "castel-di-pietra": [{
      "hkey": "e6f56686",
      "slug": "gavorrano",
      "name": "Gavorrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a7c2a71c": [{
      "hkey": "3164d56e",
      "slug": "filare-boschetto-miniera",
      "name": "Filare-Boschetto-Miniera",
      "primary": true,
      "skipSearch": false
    }],
    "filare": [{
      "hkey": "3164d56e",
      "slug": "filare-boschetto-miniera",
      "name": "Filare-Boschetto-Miniera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;